import React, { Fragment, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, Spinner, Button } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link } from 'react-router-dom'
// img

import avatars11 from '../../../assets/images/avatars/01.png'
import avatars22 from '../../../assets/images/avatars/avtar_1.png'
import avatars33 from '../../../assets/images/avatars/avtar_2.png'
import avatars44 from '../../../assets/images/avatars/avtar_3.png'
import avatars55 from '../../../assets/images/avatars/avtar_4.png'
import avatars66 from '../../../assets/images/avatars/avtar_5.png'
import avatars2 from '../../../assets/images/avatars/02.png'
import avatars3 from '../../../assets/images/avatars/03.png'
import avatars4 from '../../../assets/images/avatars/04.png'
import avatars5 from '../../../assets/images/avatars/05.png'


import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import pages2 from '../../../assets/images/pages/02-page.png'

import ShareOffcanvas from '../../../components/partials/components/shareoffcanvas'
import { userSignal } from '../../../signal/userSignal';
import { useMutation } from 'react-query';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import { toast } from 'react-toastify';

const UserProfile = () => {
   const [toggler, setToggler] = useState();
   const [image, setImage] = useState(userSignal.value?.user?.profileURL !== "" ? userSignal.value?.user?.profileURL : avatars11)
   const [phoneNumber, setPhoneNumber] = useState(userSignal.value?.user?.phoneNumber)
   const [designation, setDesignation] = useState(userSignal.value?.user?.designation)
   const [password, setPassword] = useState(userSignal.value?.user?.password)
   const [name, setName] = useState(userSignal.value?.user?.name)

   const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
      headers: {
         'Content-Type': 'multipart/form-data',
         "Authorization": `Bearer ${userSignal.value?.token}`
      }
   }), {
      onSuccess: (data) => {
         if (data?.data?.status) {
            if (data?.data?.data?.length > 0) {
               setImage(data?.data?.data[0]?.url)
            } else {
               toast.error("Something went wrong")
            }
         } else {
            toast.error(data.data.message)
         }
      },
      onError: (error) => {
         console.log("error ", error)
         if (error.response?.data?.message) {
            toast.error(error.response.data.message)
         } else {
            toast.error(error.message)
         }
      }
   })

   const updateProfileMutation = useMutation((data) => axios.put(`${DEV_SERVER}/auth/v2/employee/${userSignal.value?.user?.id}`, data, {
      headers: {
         "Authorization": `Bearer ${userSignal.value?.token}`
      }
   }), {
      onSuccess: (data) => {
         if (data.data.status) {
            toast.success(data.data.message)
            userSignal.value = { ...userSignal.value, user: data?.data?.data }
         } else {
            toast.error(data.data.message)
         }
      },
      onError: (error) => {
         console.log("error ", error)
         if (error.response?.data?.message) {
            toast.error(error.response.data.message)
         } else {
            toast.error(error.message)
         }
      }
   })


   const handleFileUpload = (e) => {
      // e.preventDefault()
      let formData = new FormData()
      formData.append("media", e.target.files[0])
      imageUploadMutation.mutate(formData)
   }

   const handleSubmit = () => { 
      let body = {}
      if (phoneNumber !== userSignal.value?.user?.phoneNumber) {
         body.phoneNumber = phoneNumber
      }
      if (password !== userSignal.value?.user?.password) {
         body.password = password
      }
      if (name !== userSignal.value?.user?.name) {
         body.name = name
      }
      if (designation !== userSignal.value?.user?.designation) {
         body.designation = designation
      }
      if (image !== userSignal.value?.user?.profileURL && image !== avatars11) {
         body.profileURL = image
      }

      if (Object.keys(body)?.length > 0) {
         updateProfileMutation.mutate(body)
      }
   }

   return (
      <Fragment>
         <FsLightbox
            toggler={toggler}
            sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
         />
         <Tab.Container defaultActiveKey="first">
            <Row>
               {/* <Col lg="12">
                  <Card>
                        <Card.Body>
                           <div className="d-flex flex-wrap align-items-center justify-content-between">
                              <div className="d-flex flex-wrap align-items-center">
                                 <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                    <Image className="theme-color-default-img  img-fluid rounded-pill avatar-100" src={avatars11} alt="profile-pic"/>
                                    <Image className="theme-color-purple-img img-fluid rounded-pill avatar-100" src={avatars22} alt="profile-pic"/>
                                    <Image className="theme-color-blue-img img-fluid rounded-pill avatar-100" src={avatars33} alt="profile-pic"/>
                                    <Image className="theme-color-green-img img-fluid rounded-pill avatar-100" src={avatars55} alt="profile-pic"/>
                                    <Image className="theme-color-yellow-img img-fluid rounded-pill avatar-100" src={avatars66} alt="profile-pic"/>
                                    <Image className="theme-color-pink-img img-fluid rounded-pill avatar-100" src={avatars44} alt="profile-pic"/>
                                 </div>
                                 <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                    <h4 className="me-2 h4">Austin Robertson</h4>
                                    <span> - Web Developer</span>
                                 </div>
                              </div>
                              <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                 <Nav.Item as="li">
                                    <Nav.Link eventKey="first">Profile</Nav.Link>
                                 </Nav.Item>
                              </Nav>
                           </div>
                        </Card.Body>
                  </Card>
               </Col> */}
               {/* <Col lg="3" className="col-lg-3">
                  <Card>
                     <Card.Header>
                        <div className="header-title">
                           <h4 className="card-title">News</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <ul className="list-inline m-0 p-0">
                           <li className="d-flex mb-2">
                              <div className="news-icon me-3">
                                 <svg width="20" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" />
                                 </svg>
                              </div>
                              <p className="news-detail mb-0">there is a meetup in your city on fryday at 19:00. <Link to="#">see details</Link></p>
                           </li>
                           <li className="d-flex">
                              <div className="news-icon me-3">
                                 <svg width="20" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" />
                                 </svg>
                              </div>
                              <p className="news-detail mb-0">20% off coupon on selected items at pharmaprix </p>
                           </li>
                        </ul>
                     </Card.Body>
                  </Card>
                  <Card>
                     <Card.Header className="d-flex align-items-center justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Gallery</h4>
                        </div>
                        <span>132 pics</span>
                     </Card.Header>
                     <Card.Body>
                        <div className="d-grid gap-card grid-cols-3">
                           <Link onClick={ () => setToggler(!toggler) }  to="#">
                           <Image  src={icon4} className="img-fluid bg-soft-info rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) } to="#">
                           <Image   src={shap2} className="img-fluid bg-soft-primary rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) } to="#">
                           <Image   src={icon8} className="img-fluid bg-soft-info rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) } to="#">
                           <Image   src={shap4} className="img-fluid bg-soft-primary rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) } to="#">
                           <Image   src={icon2} className="img-fluid bg-soft-warning rounded" alt="profile-image"/>
                           </Link>
                           <Link  onClick={ () => setToggler(!toggler) }  to="#">
                           <Image src={shap6} className="img-fluid bg-soft-primary rounded" alt="profile-image"/>
                           </Link>
                           <Link to="#">
                              <Image  onClick={ () => setToggler(!toggler) } src={icon5} className="img-fluid bg-soft-danger rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) }  to="#">
                              <Image  src={shap4} className="img-fluid bg-soft-primary rounded" alt="profile-image"/>
                           </Link>
                           <Link onClick={ () => setToggler(!toggler) } to="#">
                              <Image src={icon1} className="img-fluid bg-soft-success rounded" alt="profile-image"/>
                           </Link>
                        </div>
                     </Card.Body>
                  </Card>
                  <Card>
                     <Card.Header>
                        <div className="header-title">
                           <h4 className="card-title">Twitter Feeds</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="twit-feed">
                           <div className="d-flex align-items-center mb-2">
                              <Image className="rounded-pill img-fluid avatar-50 me-3 p-1 bg-soft-danger ps-2" src={icon3} alt=""/>
                              <div className="media-support-info">
                                 <h6 className="mb-0">Figma Community</h6>
                                 <p className="mb-0">@figma20 
                                    <span className="text-primary">
                                       <svg width="15" viewBox="0 0 24 24">
                                          <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                       </svg>
                                    </span>
                                 </p>
                              </div>
                           </div>
                           <div className="media-support-body">
                              <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                              <div className="d-flex flex-wrap">
                                 <Link to="#" className="twit-meta-tag pe-2">#Html</Link>
                                 <Link to="#" className="twit-meta-tag pe-2">#Bootstrap</Link>
                              </div>
                              <div className="twit-date">07 Jan 2021</div>
                           </div>
                        </div>
                        <hr className="my-4"/>
                        <div className="twit-feed">
                           <div className="d-flex align-items-center mb-2">
                              <Image className="rounded-pill img-fluid avatar-50 me-3 p-1 bg-soft-primary" src={icon4} alt=""/>
                              <div className="media-support-info">
                                 <h6 className="mb-0">Flutter</h6>
                                 <p className="mb-0">@jane59
                                    <span className="text-primary">
                                       <svg width="15" viewBox="0 0 24 24">
                                          <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                       </svg>
                                    </span>
                                 </p>
                              </div>
                           </div>
                           <div className="media-support-body">
                              <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                              <div className="d-flex flex-wrap">
                                 <Link to="#" className="twit-meta-tag pe-2">#Js</Link>
                                 <Link to="#" className="twit-meta-tag pe-2">#Bootstrap</Link>
                              </div>
                              <div className="twit-date">18 Feb 2021</div>
                           </div>
                        </div>
                        <hr className="my-4"/>
                        <div className="twit-feed">
                           <div className="d-flex align-items-center mb-2">
                                 <Image className="rounded-pill img-fluid avatar-50 me-3 p-1 bg-soft-warning pt-2" src={icon2} alt=""/>
                              <div className="mt-2">
                                 <h6 className="mb-0">Blender</h6>
                                 <p className="mb-0">@blender59
                                    <span className="text-primary">
                                       <svg width="15" viewBox="0 0 24 24">
                                          <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                       </svg>
                                    </span>
                                 </p>
                              </div>
                           </div>
                           <div className="media-support-body">
                              <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                              <div className="d-flex flex-wrap">
                                 <Link to="#" className="twit-meta-tag pe-2">#Html</Link>
                                 <Link to="#" className="twit-meta-tag pe-2">#CSS</Link>
                              </div>
                              <div className="twit-date">15 Mar 2021</div>
                           </div>
                        </div>
                     </Card.Body>
                  </Card>
               </Col> */}
               <Col lg="9" style={{ margin: "0px auto" }}>
                  <Tab.Content className="profile-content">
                     <Tab.Pane eventKey="first" id="profile-feed">
                        <Card>
                           <Card.Header className="d-flex align-items-center justify-content-between pb-4">
                              {/* <img src={userSignal.value?.user?.profileURL !== "" ? userSignal.value?.user?.profileURL : avatars11} style={{borderRadius: "50%", margin: "0px auto", position: "relative"}} width={"200px"} height={"200px"} /> */}

                              <div class="icon-box" style={{ margin: "0px auto", width: "200px", height: "200px", borderRadius: "50%" }}>
                                 <div class="overlay">
                                    <button type="button" style={{ position: "relative" }} data-toggle="copy" data-copy-target="#svg-container-47" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy" class="btn btn-btn btn-sm btn-soft-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Loading..." : "Change"} <input type="file" id="file" disabled={imageUploadMutation.isLoading} onChange={(e) => handleFileUpload(e)} style={{ position: "absolute", left: "0%", opacity: 0, cursor: "pointer" }} /></button>

                                 </div>
                                 <div id="svg-container-47"><img src={image} style={{ borderRadius: "50%", margin: "0px auto", position: "relative" }} width={"200px"} height={"200px"} />
                                 </div>
                              </div>
                           </Card.Header>
                           <Card.Body className="p-0">
                              <div style={{ display: "flex", margin: "0px 1rem", flexDirection: "column", alignItems: "center", columnGap: "1rem", rowGap: "1rem" }}>
                                 <div style={{ display: "flex", columnGap: "1rem" }}>
                                    <Form.Group className="form-group">
                                       <Form.Label htmlFor="name" className="">Name</Form.Label>
                                       <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder=" " value={name} onChange={(e) => setName(e.target.value)} />
                                    </Form.Group >
                                    <Form.Group className="form-group">
                                       <Form.Label htmlFor="designation" className="">designation</Form.Label>
                                       <Form.Control type="text" className="" id="designation" aria-describedby="designation" placeholder=" " value={designation} onChange={(e) => setDesignation(e.target.value)} />
                                    </Form.Group >
                                 </div>
                                 <div style={{ display: "flex", columnGap: "1rem" }}>
                                    <Form.Group className="form-group">
                                       <Form.Label htmlFor="phoneNumber" className="">Phone Number</Form.Label>
                                       <Form.Control type="text" className="" id="phoneNumber" aria-describedby="phoneNumber" placeholder=" " value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                                    </Form.Group >
                                    <Form.Group className="form-group">
                                       <Form.Label htmlFor="password" className="">password</Form.Label>
                                       <Form.Control type="password" className="" id="password" aria-describedby="password" placeholder=" " value={password} onChange={(e) => setPassword(e.target.value)} />
                                    </Form.Group >
                                 </div>
                                 <div className="d-flex justify-content-center" style={{marginBottom: "1rem"}}>
                                    {updateProfileMutation.isLoading ? <Button variant="primary" type="button" disabled>
                                       <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                       Loading...
                                    </Button> :
                                       <Button onClick={handleSubmit} type="button" variant="btn btn-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Uploading..." : "Submit"}</Button>
                                    }
                                 </div>
                              </div>
                           </Card.Body>
                        </Card>
                     </Tab.Pane>
                  </Tab.Content>
               </Col>
            </Row>
         </Tab.Container>
      </Fragment>
   )

}

export default UserProfile;